import { render, staticRenderFns } from "./TaskView.vue?vue&type=template&id=55fe44a7&scoped=true&"
import script from "./TaskView.vue?vue&type=script&lang=js&"
export * from "./TaskView.vue?vue&type=script&lang=js&"
import style0 from "./TaskView.vue?vue&type=style&index=0&id=55fe44a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fe44a7",
  null
  
)

export default component.exports